<template>

  <div class="app-wrapper">

    <Header/>

    <div class="app-content">
      <router-view/>
    </div>

    <Footer/>

    <Cookie/>

  </div>

</template>

<script>
import Header from "@/views/Components/Header.vue";
import Footer from "@/views/Components/Footer.vue";
import ControllApp from "@/Library/Controll/App"
import {mapActions, mapState} from "vuex";
import Cookie from "@/views/Components/Cookie.vue";

export default {
  name: "App",
  components: {
    Cookie,
    Footer,
    Header
  },
  mixins: [ControllApp],
  methods: {
    /**
     * Dołączanie metod z VUEX'a
     */
    ...mapActions({
      langArrLoad: "app/langArrLoad"
    }),
  },
  computed: {},
  async mounted() {

    await this.langArrLoad()

  }
}
</script>

<style lang="scss">

*, *::before, *::after {
  margin: 0;
  padding: 0;
  border: 0;
  box-sizing: border-box;
  font-family: "Outfit", sans-serif;
  word-wrap: break-word;
}

html, body {
  height: 100%;
  font-size: 16px;
}

html.transition-off *, html.transition-off *::before, html.transition-off *::after {
  transition: none !important;
}

.app-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-content {

}

.sticky {
  position: sticky;
  transition: all 0.25s ease 0s;
}

.header.header--first-scroll + .menu-mobile + .app-content .sticky {
  top: 132px;
}

.header.header--hide + .menu-mobile + .app-content .sticky {
  top: 30px;
}

.header.header--show + .menu-mobile + .app-content .sticky {
  top: 132px;
}

html.contrast {
  color-scheme: dark;

  & .header {

    &--top-position {

      & .menu--main {

        & > .menu__item {

          & > a {

            & span:first-child {
              color: #fff
            }

            & svg {
              stroke: #fff;
            }
          }

          &:hover {

            & > a {

              & > span {
                color: gold;
              }

              & > svg {
                stroke: gold;
              }
            }
          }
        }
      }

      & .circle-btn {
        border-color: #fff;
        color: #fff;

        &:hover {
          border-color: gold;
        }

        &--animation {
          background-color: gold;
        }
      }
    }
  }

  & .slider__search-line svg path, & .image.image--second svg path, & .image.image--third svg path {
    fill: gold;
  }

  & .vc-container {
    background-color: #000;
  }

  & .vc-title {
    color: #d2d2d2;
  }

  & .loading:before {
    border-color: #d2d2d2;
    border-top-color: gold;
    border-bottom-color: gold;
  }
}

/**
 * Plik style.scss
 */
a {
  text-decoration: none;
  color: #000;
}

.loading {
  position: relative;
  min-height: 100px;
}

.loading > * {
  opacity: 0.1;
  -webkit-transition: all 0.30s ease-in-out;
  transition: all 0.30s ease-in-out;
}

.loading:before {
  position: absolute;
  content: "";
  left: 50%;
  top: 60px;
  margin-left: -30px;
  margin-top: -30px;
  border: 3px solid #fff;
  border-radius: 50%;
  border-top: 3px solid rgb(73, 78, 155);
  border-bottom: 3px solid rgb(73, 78, 155);
  width: 60px;
  height: 60px;
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
  opacity: 1 !important;
  -webkit-transition: all 0.45s ease-in-out;
  transition: all 0.45s ease-in-out;
  z-index: 2;
}

.loading::after {
  position: absolute;
  content: "Trwa ładowanie danych";
  left: 0px;
  top: 80px;
  text-align: center;
  width: 100%;
  margin-top: 30px;
  opacity: 1 !important;
  color: rgb(100, 100, 100);

}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

html.contrast {

  & input[type="text"], & textarea, & input[type="date"], & input[type="datetime-local"] {
    background-color: #000;
    color: #d2d2d2;
    border-color: #d2d2d2;
  }

  & select {

    & option {
      color: #d2d2d2;
    }

    &:focus {
      border-color: gold;
    }
  }
}

.search .row-nice__input {
  border-radius: 100px;
}

input[type="text"], textarea, input[type="date"], input[type="datetime-local"] {
  width: 100%;
  height: 45px;
  padding: 0 15px;
  background-color: #f9f9f9;
  outline: none;
  color: rgb(100 100 100);
  font-size: 14px;
  border-radius: 0.25rem;
  border: 1px solid #ededed;
  transition: all 0.25s ease 0s;

  &:focus {
    border-color: rgb(73, 78, 155);
  }
}

textarea {
  padding: 15px;
  height: 100px;
  resize: vertical;
}

.row-nice.row-nice--icon > input[type="text"] {
  padding: 0 39px 0 15px;
}

html.contrast {

  & input[type=range]::-webkit-slider-runnable-track {
    background-color: gold;
  }

  & input[type=range]::-webkit-slider-thumb {
    box-shadow: 3px 3px 7px #807f57;
    background: gold;

    &:hover {
      background: #d7b20d;
    }
  }

  & input[type=range]:focus::-webkit-slider-runnable-track {
    background: gold;
  }

  & input[type=range]::-moz-range-track {
    background: gold;
  }

  & input[type=range]::-moz-range-thumb {
    box-shadow: 3px 3px 7px #807f57;
    background: gold;
  }

  & input[type=range]::-ms-fill-lower {
    background: gold;
  }

  & input[type=range]::-ms-fill-upper {
    background: gold;
  }

  & input[type=range]::-ms-thumb {
    box-shadow: 3px 3px 7px #807f57;
    background: gold;
  }

  & input[type=range]:focus::-ms-fill-lower {
    background: gold;
  }

  & input[type=range]:focus::-ms-fill-upper {
    background: gold;
  }
}

input[type=range] {
  height: 32px;
  -webkit-appearance: none;
  width: 100%;
  background: transparent;
}

input[type=range]:focus {
  outline: none;
}

input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 0px 0px 0px #000000;
  background: rgb(73, 78, 155);
  border-radius: 50px;
  border: 0px solid #000000;
}

input[type=range]::-webkit-slider-thumb {
  box-shadow: 3px 3px 7px #576580;
  border: 3px solid #FFFFFF;
  height: 20px;
  width: 20px;
  border-radius: 50px;
  background: rgb(73, 78, 155);
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -8.5px;

  &:hover {
    background: rgb(56, 59, 117);
  }
}

input[type=range]:focus::-webkit-slider-runnable-track {
  background: rgb(73, 78, 155);
}

input[type=range]::-moz-range-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 0px 0px 0px #000000;
  background: rgb(73, 78, 155);
  border-radius: 50px;
  border: 0px solid #000000;
}

input[type=range]::-moz-range-thumb {
  box-shadow: 3px 3px 7px #576580;
  border: 3px solid #FFFFFF;
  height: 20px;
  width: 20px;
  border-radius: 50px;
  background: rgb(73, 78, 155);
  cursor: pointer;
}

input[type=range]::-ms-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  color: transparent;
}

input[type=range]::-ms-fill-lower {
  background: rgb(73, 78, 155);
  border: 0px solid #000000;
  border-radius: 100px;
  box-shadow: 0px 0px 0px #000000;
}

input[type=range]::-ms-fill-upper {
  background: rgb(73, 78, 155);
  border: 0px solid #000000;
  border-radius: 100px;
  box-shadow: 0px 0px 0px #000000;
}

input[type=range]::-ms-thumb {
  margin-top: 1px;
  box-shadow: 3px 3px 7px #576580;
  border: 3px solid #FFFFFF;
  height: 20px;
  width: 20px;
  border-radius: 50px;
  background: rgb(73, 78, 155);
  cursor: pointer;
}

input[type=range]:focus::-ms-fill-lower {
  background: rgb(73, 78, 155);
}

input[type=range]:focus::-ms-fill-upper {
  background: rgb(73, 78, 155);
}

.loader {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  border: 4px solid;
  border-color: rgba(100, 100, 100, 0.15) rgba(100, 100, 100, 0.25) rgba(100, 100, 100, 0.35) rgba(100, 100, 100, 0.5);
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

select {
  border: 1px solid #ededed;
  border-radius: 4px;
  font-size: 16px;
  height: 45px;
  line-height: 43px;
  padding: 0 30px 0 15px;
  outline: none;

  & option {
    color: rgb(100, 100, 100);
  }

  &:focus {
    border-color: rgb(73, 78, 155);
  }

  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  appearance: none;
}

/**
 * Koniec pliku style.scss
 */

.map-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, rgba(0, 128, 0, 0.8) 0%, rgba(0, 0, 0, 0.1) 0);
  z-index: 2;
}

#map .leaflet-div-icon {
  width: 0;
  height: 0;
  border: 0;
  padding: 0;
  margin: 0;
  background-color: transparent;

  & .custom-marker {
    border-radius: 50% 50% 50% 0;
    border: 1px solid #fff;
    width: 30px;
    height: 30px;
    transform: rotate(-45deg);

    margin-top: -40px;
    margin-left: -15px;

    display: flex;
    align-items: center;
    justify-content: center;

    & > .material-symbols-outlined {
      font-size: 18px;
      font-weight: 300;
      color: #fff;
      transform: rotate(45deg);
    }
  }
}

.leaflet-container {

  &:after {
    font-family: "Outfit", sans-serif !important;
    font-size: 16px !important;
    z-index: 1001 !important;
  }

  &.leaflet-gesture-handling-scroll-warning {

    & + .map__filter {

      &:after {

      }
    }
  }
}

.article__part, .event__part {

  & ul, & ol {
    margin-left: 30px;
  }

  & img {
    width: 100%;
  }
}

/**
 * Google Material Symbols
 */
/* fallback */
@font-face {
  font-family: 'Material Symbols Outlined';
  font-style: normal;
  font-weight: 100 700;
  src: url("@/assets/google-symbols/material-symbols-outlined.woff2") format('woff2');
}

.material-symbols-outlined {
  font-family: 'Material Symbols Outlined';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;
}

/**
 * End Google Materials Symbols
 */

/**
 * Google Font
 */
/* latin */
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src: url("@/assets/google-fonts/fw100.woff2") format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

/* latin */
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 200;
  font-display: swap;
  src: url("@/assets/google-fonts/fw200.woff2") format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

/* latin */
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url("@/assets/google-fonts/fw300.woff2") format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

/* latin */
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url("@/assets/google-fonts/fw400.woff2") format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

/* latin */
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url("@/assets/google-fonts/fw500.woff2") format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

/* latin */
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url("@/assets/google-fonts/fw600.woff2") format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

/* latin */
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url("@/assets/google-fonts/fw700.woff2") format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

/* latin */
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url("@/assets/google-fonts/fw800.woff2") format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

/* latin */
@font-face {
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url("@/assets/google-fonts/fw900.woff2") format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

/**
 * End Google Font
 */

</style>